__turbopack_context__.v({
  "checkmark": "RatingSelector-module__puckkq__checkmark",
  "filled": "RatingSelector-module__puckkq__filled",
  "label": "RatingSelector-module__puckkq__label",
  "ratingContainer": "RatingSelector-module__puckkq__ratingContainer",
  "star": "RatingSelector-module__puckkq__star",
  "stars": "RatingSelector-module__puckkq__stars",
  "text": "RatingSelector-module__puckkq__text",
  "toggleContainer": "RatingSelector-module__puckkq__toggleContainer",
});
